export const shape = { borderRadius: 6 };
